import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Spinner } from '@telus-uds/components-web';

import {
  ApproveButton,
  ButtonWrapper,
  DeclineButton,
  EditOverlay,
  PendingApprovalLabel
} from '../../css';

import request from '../../../utils/request';

const Overlay = ({ email, fetchData, setInDisableMode }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const resetState = () => {
    setIsDeleting(false);
    setInDisableMode(false);
    fetchData();
  };

  const handleAction = async () => {
    setIsDeleting(true);
    try {
      const result = await request.put(`/disable-user`, {
        email,
        status: 1
      });
      if (result && result.status === 200) {
        setInDisableMode(false);
        fetchData();
      }
    } catch (err) {
      resetState();
      throw err;
    }
  };

  return (
    <EditOverlay>
      <Spinner label="Disabling..." show={isDeleting}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: '100%',
            alignItems: 'center'
          }}
        >
          <PendingApprovalLabel center>
            Are you sure you want to disable users profile?
          </PendingApprovalLabel>
          <ButtonWrapper center>
            <ApproveButton onClick={handleAction}>Confirm</ApproveButton>
            <DeclineButton onClick={() => setInDisableMode(false)}>
              Cancel
            </DeclineButton>
          </ButtonWrapper>
        </div>
      </Spinner>
    </EditOverlay>
  );
};

Overlay.propTypes = {
  email: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  setInDisableMode: PropTypes.func.isRequired
};

export default Overlay;
